export default __webpack_public_path__ + "static/media/iconExit.6bd7062c.svg";